import type { Notification } from './types';

export const dummyNotifications: Notification[] = [
  {
    id: '1',
    type: 'invoice',
    initials: 'BA',
    title: 'Bhutan Airlines',
    message: 'You received an invoice of',
    amount: '$1,089.33',
    timeAgo: '1m',
    timestamp: new Date(Date.now() - 1 * 60 * 1000).toISOString(),
    isRead: false,
    details: {
      invoiceId: 'BT-883BK2',
      internalInvoiceId: '899324923',
      createdDate: '12/20/2023',
      dueDate: '01/20/2024',
      payTo: {
        name: 'MyBhutan',
        email: 'contact@mybhutan.com',
        phone: '+1-818-824-8826',
      },
      billTo: {
        name: 'Hotel Osel',
        email: 'sales@oselbhutan.com',
      },
      items: [
        { name: 'Accommodation', quantity: 2, unitPrice: 300.0, amount: 600.0 },
        { name: 'Food and travel', quantity: 1, unitPrice: 500.0, amount: 500.0 },
      ],
      subtotal: 1100.0,
      processingFee: 22.11,
      total: 1122.11,
    },
  },
  {
    id: '2',
    type: 'invoice',
    initials: 'BT',
    title: 'Bhutan Times',
    message: 'You received an invoice of',
    amount: '$250',
    timeAgo: '3m',
    timestamp: new Date(Date.now() - 3 * 60 * 1000).toISOString(),
    isRead: false,
    details: {
      invoiceId: 'BT-445RT9',
      internalInvoiceId: '899324988',
      createdDate: '12/18/2023',
      dueDate: '01/18/2024',
      payTo: {
        name: 'MyBhutan',
        email: 'contact@mybhutan.com',
        phone: '+1-818-824-8826',
      },
      billTo: {
        name: 'Bhutan Times Ltd',
        email: 'billing@bhutantimes.bt',
      },
      items: [{ name: 'Subscription Fee', quantity: 1, unitPrice: 250.0, amount: 250.0 }],
      subtotal: 250.0,
      processingFee: 7.45,
      total: 257.45,
    },
  },
  {
    id: '3',
    type: 'payment',
    avatar: '',
    title: 'Yangchen Lhmao',
    message: 'You received a payment of',
    amount: '$540',
    timeAgo: '3d',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    isRead: true,
    details: {
      invoiceId: 'BT-334KL7',
      internalInvoiceId: '899324712',
      createdDate: '12/15/2023',
      dueDate: '12/25/2023',
      payTo: {
        name: 'MyBhutan',
        email: 'contact@mybhutan.com',
        phone: '+1-818-824-8826',
      },
      billTo: {
        name: 'Yangchen Lhmao',
        email: 'yangchen.lhmao@email.bt',
      },
      items: [{ name: 'Tour Package', quantity: 1, unitPrice: 540.0, amount: 540.0 }],
      subtotal: 540.0,
      processingFee: 16.07,
      total: 556.07,
    },
  },
  {
    id: '4',
    type: 'payment',
    avatar: '',
    title: 'Tenzin Dorji Wangchuk',
    message: 'You received a payment of',
    amount: '$20.28',
    timeAgo: '4d',
    timestamp: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    isRead: true,
    details: {
      invoiceId: 'BT-221MN4',
      internalInvoiceId: '899324556',
      createdDate: '12/14/2023',
      dueDate: '12/24/2023',
      payTo: {
        name: 'MyBhutan',
        email: 'contact@mybhutan.com',
        phone: '+1-818-824-8826',
      },
      billTo: {
        name: 'Tenzin Dorji Wangchuk',
        email: 'tenzin.wangchuk@email.bt',
      },
      items: [{ name: 'Service Fee', quantity: 1, unitPrice: 20.28, amount: 20.28 }],
      subtotal: 20.28,
      processingFee: 0.6,
      total: 20.88,
    },
  },
  {
    id: '5',
    type: 'refund',
    initials: 'BG',
    title: 'Bhutan Groceries',
    message: 'You received a refund of',
    amount: '$250.89',
    timeAgo: '4d',
    timestamp: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    isRead: true,
    details: {
      invoiceId: 'BT-998LK3',
      internalInvoiceId: '899323445',
      createdDate: '12/10/2023',
      dueDate: '12/20/2023',
      payTo: {
        name: 'MyBhutan',
        email: 'contact@mybhutan.com',
        phone: '+1-818-824-8826',
      },
      billTo: {
        name: 'Bhutan Groceries',
        email: 'admin@bhutangroceries.bt',
      },
      items: [{ name: 'Refund - Order #12345', quantity: 1, unitPrice: 250.89, amount: 250.89 }],
      subtotal: 250.89,
      processingFee: 7.47,
      total: 258.36,
    },
  },
  {
    id: '6',
    type: 'system',
    initials: 'S',
    title: 'System',
    message: 'Your dispute of CK-A18178D1 is approved.',
    timeAgo: '5d',
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    isRead: true,
  },
  {
    id: '7',
    type: 'invoice',
    initials: 'BH',
    title: 'Bhutan Hotel',
    message: 'You received an invoice of',
    amount: '$3,456.56',
    timeAgo: '2w',
    timestamp: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
    isRead: true,
    details: {
      invoiceId: 'BT-756HG2',
      internalInvoiceId: '899322134',
      createdDate: '12/06/2023',
      dueDate: '01/06/2024',
      payTo: {
        name: 'MyBhutan',
        email: 'contact@mybhutan.com',
        phone: '+1-818-824-8826',
      },
      billTo: {
        name: 'Bhutan Hotel',
        email: 'reservations@bhutanhotel.bt',
      },
      items: [
        { name: 'Hotel Booking', quantity: 5, unitPrice: 650.0, amount: 3250.0 },
        { name: 'Additional Services', quantity: 1, unitPrice: 206.56, amount: 206.56 },
      ],
      subtotal: 3456.56,
      processingFee: 102.96,
      total: 3559.52,
    },
  },
];
